/**
 * header.js
 * File for website header
 */

var $ = jQuery;

jQuery(document).ready(function($) {

    // logo sizing on scroll
    function headLogoSizing() {
        if ($(window).scrollTop() > 100) {
            $('.page-header').addClass('scrolling');
        }

        if ($(window).scrollTop() < 50) {
            $('.page-header').removeClass('scrolling');
        }
    }   

    $(window).scroll(function() {
        headLogoSizing();
    }).scroll();    

});

jQuery(window).load(function() {

    // svg blob sizing in header
    $(window).resize(function() {
        $('.banner .svg-blob-background .image-blob').css('min-height', $('.banner .svg-blob-background .image-blob').width() * 0.8);
    }).resize();    

    setTimeout(function() {

        // add "loaded" class when page has been fully loaded
        jQuery('header.page-header').addClass('loaded');

        // ensure svg blob sizing in header after page load
        $('.banner .svg-blob-background .image-blob').css('min-height', $('.banner .svg-blob-background .image-blob').width() * 0.8);

    }, 666);    

});